import { useState, useEffect } from 'react';

export function useLang() {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem('lang');
    if (stored === 'es' || stored === 'en') return stored;
    if (stored && typeof stored === 'string') {
      const prefix = stored.substring(0, 2).toLowerCase();
      if (prefix === 'es' || prefix === 'en') return prefix;
    }
    return 'es';
  });

  useEffect(() => {
    const handleGlobalLang = (e) => {
      const newLang = e.detail;
      if (newLang === 'es' || newLang === 'en') {
        setLang(newLang);
      } else if (newLang && typeof newLang === 'string') {
        const prefix = newLang.substring(0, 2).toLowerCase();
        if (prefix === 'es' || prefix === 'en') {
          setLang(prefix);
        } else {
          setLang('es');
        }
      } else {
        setLang('es');
      }
    };
    window.addEventListener('languageChange', handleGlobalLang);
    return () => window.removeEventListener('languageChange', handleGlobalLang);
  }, []);

  return lang;
}

export default useLang;
